/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PartnerOperatorPagedList } from '../../models/partner-operator-paged-list';
import { PartnerOperatorSearchBody } from '../../models/partner-operator-search-body';
import { SortDirection } from '../../models/sort-direction';

export interface SearchPartnerOperatorList$Params {

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * Indicates the field to use for sorting the data:
 *   * NAME : the partner operator name
 */
  sortFieldName?: 'NAME';

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;
  
    /**
     * Body for search partner operator
     */
    body?: PartnerOperatorSearchBody
}

export function searchPartnerOperatorList(http: HttpClient, rootUrl: string, params?: SearchPartnerOperatorList$Params, context?: HttpContext): Observable<StrictHttpResponse<PartnerOperatorPagedList>> {
  const rb = new RequestBuilder(rootUrl, searchPartnerOperatorList.PATH, 'post');
  if (params) {
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sortFieldName', params.sortFieldName, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PartnerOperatorPagedList>;
    })
  );
}

searchPartnerOperatorList.PATH = '/partners/operator/search';
